import React, { useEffect, useRef, useState } from "react";
import {Services} from "../../network/Services";
import SearchBar from "../CommonComponents/SearchBar";
import PaymentForm from "../CommonComponents/Paymentform";
import { capitalizeFirst, federal_way_plazaId, formatToUS, isValidFuntion } from "../../control/Constant";
import ReusableSelect from "../ReusableSelect";
import SearchableSelect from "../CustomSelect";
import { getLoggedUserId } from "../../network/auditFields";



const FederalWay = ({paymentData,setPaymentData,setuseLoader,setSelectedUserData,setToast}) => {
    const [businessLines,setBusinessLines] = useState([])
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchText,setSearchtext] = useState('')
    const [results, setResults] = useState([]);
    const [selectedUser,setSelecteduser] = useState({tenantName: '',unitNumber: ''})
    const [showUserForm,setshowUserForm] = useState(false)
    const [tenantList,setTenantlist] = useState([])
    const [searchData, setsearchData] = useState(null);
    const [customTenantName, setCustomTenantName] = useState("");
    const [originalTenantData, setOriginalTenantData] = useState(null);
    const [editClick, setEditClick] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    let confirmResolveRef = useRef(null);
    


  //   const businessLines = {
  //   'rent_collection': 'Rent Collection',
  //   'parking_fees': 'Parking Fees',
  //   'late_fees': 'Late Fees',
  //   'security_deposits': 'Security Deposits',
  //   'utilities': 'Utilities',
  //   'maintenance_fees': 'Maintenance Fees',
  //   'other': 'Other'
  // };

  useEffect(()=>{
    getSubscriptionBysubtenantfunc()
    fetchTenantList()
  },[])

    useEffect(() => {
      window.setEditClickGlobal = (value) => {
        setEditClick(value);
        window.editMode = value;
      };
      window.getUserDetails = () => paymentData;
      window.isViewOnlyMode = () => isValidFuntion(selectedUser.memberId);
      window.handleSaveGlobal = handleSaveClick;
      window.handleCancelGlobal = handleCancelClick;
      window.addUserGlobal = () => {
        if (!isValidFuntion(selectedUser.memberId)) {
          addUser();
        }
      };
      window.isEditClicked = editClick;
    }, [paymentData, editClick, selectedUser]);

  const getSubscriptionBysubtenantfunc = () => {
    setuseLoader(true)
    let getSubscriptionBysubtenantpromise = Services.getSubscriptionBysubtenant(federal_way_plazaId)
    getSubscriptionBysubtenantpromise.then((res)=>{
      console.log(res,'resgetSubscriptionBysubtenantfunc')
      setBusinessLines(res.data.data)
      setuseLoader(false)
    }).catch((err)=>{
      console.log(err,'err')
      setuseLoader(false)
    })
  }

  const handleSearch = async () => {
    if (!searchText.trim()){
    // setshowUserForm(false)
    return;}

    // let inputData = {
    //     "subtenantId": 3,
    //     "userType": "ALLCLIENT",
    //     "searchtext": searchText || null,
    //     // "roleId":18
    // }
    // setuseLoader(true)
    // Services?.getUserListByRoleIdservice(inputData).then((res) => {
    // if(res?.data) {
    //   console.log('User76567data:', res.data?.data);
    //   setResults(res.data?.data || []);
    //   setShowDropdown(true);
    //   setuseLoader(false)
    //   if(res?.data?.data?.length == 0){
    //     setResults([]);
    //     setshowUserForm(true)
    //     setSelecteduser(() => ({
    //       fullName: '',
    //       primaryEmail: '',
    //       primaryMobile: '',
    //     }));
    //     setShowDropdown(false);
    //   }
    // }
    // }).catch((error) => {
    //   setResults([]);
    //   setShowDropdown(false);
    //   setuseLoader(false)
    // });
  };

  const runApis = () => {
    if (!searchText?.trim()) return;
    setuseLoader(true)
    Services?.getTenantslist(federal_way_plazaId,searchText).then((res) => {
      if (res?.data) {
        setResults(res.data?.data || []);
        setShowDropdown(true);
        setuseLoader(false)
        if(res?.data?.data?.length == 0){
        setshowUserForm(true)
        }
      }
    }).catch((error) => {
        setResults([]);
        setSelecteduser((prev) => ({
        ...prev,
        memberId:'',
        tenantName: '',
        unitNumber: '',
      }));
      setPaymentData((prev)=>({
        ...prev,
        unitNumber:''
      }))
        // setshowUserForm(true)
        // setShowDropdown(false);
        setuseLoader(false)
    });
    }

    const setSearchData =(data)=>{
    // setUserlist(data)
    data = (typeof data) === "string" ? JSON.parse(data) : data;
    const {tenantName,unitNumber,userId,tenantId} = data
    console.log(data,"sgdhgshssetSearchData")
      setSelecteduser((prev) => ({
        ...prev,
        memberId:userId,
        tenantName: tenantName,
        unitNumber: unitNumber,
        clientUserId: userId, // Add clientUserId for Federal Way Plaza
        loginUserId: userId,  // Add loginUserId for Federal Way Plaza
        tenantId: tenantId
      }));
      setPaymentData((prev)=>({
        ...prev,
        unitNumber:unitNumber
      }))
      setSelectedUserData((prev) => ({
        ...prev,
        memberId:userId,
        fullName: tenantName,
        tenantId:tenantId,
        clientUserId: userId, // Add clientUserId for Federal Way Plaza payments
        loginUserId: userId,  // Add loginUserId for Federal Way Plaza payments
        tenantName: tenantName,
        unitNumber: unitNumber
      }))
      // setshowUserForm(true)
      setOriginalTenantData(data);
      setSearchtext(tenantName);
      setShowDropdown(false);
    }

    const onChangePayment = (e) => {
      const value = e
      const selectedName = businessLines?.find((s)=>{return s.subscriptionId == e}).subscriptionName;
      setPaymentData(prev => ({
        ...prev,
        lineOfBusiness: value,
        'serviceName': selectedName
      }));
    }

    const addUser = () => {
      console.log(selectedUser,"selectedUser",paymentData.unitNumber,searchText)

      let jsonObj = {
          "tenantId": 0,
          "userId": "",
          "subtenantId": federal_way_plazaId,
          "tenantName": searchText,
          "unitNumber": paymentData?.unitNumber,
          "upsertedBy": getLoggedUserId() || "Payment System",
          "isActive": true
        }
      setuseLoader(true)
      const addTenantpromise = Services.upsertTenantdata(jsonObj)
      setuseLoader(false)
      addTenantpromise.then((res)=>{
        setuseLoader(false)
        console.log(res,"resupsertTenantdata")
        fetchTenantList();
        setSearchData(res.data.data)
      }).catch((err)=>{
        setuseLoader(false)
        console.log(err,"errupsertTenantdata")
      })
    }

    const fetchTenantList = () => {
    setuseLoader(true)
    Services?.getTenantslist(federal_way_plazaId,'').then((res) => {
    setuseLoader(false)
    if (res?.data) {
        console.log(res,"resfetchTenantList")
        setTenantlist(res?.data?.data || [])
        // setResults(res.data?.data || []);
        // setShowDropdown(true);
        // setuseLoader(false)
        // if(res?.data?.data?.length == 0){
        // setshowUserForm(true)
        // }
      }
    }).catch((error) => {
      //   setResults([]);
      //   setSelecteduser((prev) => ({
      //   ...prev,
      //   memberId:'',
      //   tenantName: '',
      //   unitNumber: '',
      // }));
      // setPaymentData((prev)=>({
      //   ...prev,
      //   unitNumber:''
      // }))
        // setshowUserForm(true)
        // setShowDropdown(false);
        setuseLoader(false)
    });
    }

  const handleInputChange = (field, e) => {
    setPaymentData({...paymentData,[field]: e});
  }

  const handleEditClick = () => {
    setEditClick(true);
  };

  const handleSaveClick = async () => {
    setEditClick(false);
    if (!originalTenantData) return;
    const jsonObj = {
      ...originalTenantData,
      tenantName: paymentData?.tenantName || originalTenantData?.tenantName,
      unitNumber: paymentData?.unitNumber || originalTenantData?.unitNumber,
      updatedBy: originalTenantData.userId,
      userId: originalTenantData.userId
    };
    setuseLoader(true);
    const res = await Services.upsertTenantdata(jsonObj);
    setuseLoader(false);
    setSearchData(res.data.data);
    fetchTenantList();
    setToast({ type: "success", message: "Tenant updated successfully" });
    setuseLoader(false)
  };

  const handleCancelClick = () => {
    setEditClick(false);
  };

    const handleBeforeOpen = () => {
    return new Promise((resolve) => {
      if (window.isEditClicked) {
        confirmResolveRef.current = resolve;
        setShowConfirm(true);
      } else {
        resolve(true);
      }
      if (window.isViewOnlyMode && window.isViewOnlyMode()) {
        resolve(true);
        return;
      }
      const details = window.getUserDetails ? window.getUserDetails() : {};
      const isEmpty = Object.values(details).every(
        (val) => val === "" || val === null || val === undefined
      );
      if (isEmpty) {
        resolve(true);
        return;
      }
      if (typeof window.setEditClickGlobal === "function") {
        confirmResolveRef.current = resolve;
        setShowConfirm(true);
      } else {
        resolve(true);
      }
    });
  };

  const handleSave = () => {
    if (typeof window.isEditClicked !== "undefined" && !window.isEditClicked) {
      if (typeof window.addUserGlobal === "function") {
        window.addUserGlobal();
      }
    } else {
      if (typeof window.handleSaveGlobal === "function") {
        window.handleSaveGlobal();
      }
    }
    confirmResolveRef.current(false);
    setShowConfirm(false);
  };

  const handleDiscard = () => {
    if (typeof window.handleCancelGlobal === "function") {
      window.handleCancelGlobal();
    }
    confirmResolveRef.current(false);
    setShowConfirm(false);
  };

  return (
    <div className="space-y-6">

      {/* Tenant Information */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Tenant Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            {/* <label className="block text-sm font-medium text-gray-700 mb-1">
              Tenant Name
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              value={paymentData.tenantName || ''}
              onChange={(e) => handleInputChange('tenantName', e.target.value)}
            /> */}
            {/* <SearchBar reference="FederalWay" showDropdown={showDropdown} setMatterNumber ={setSearchtext} matterNumber={searchText} handleSearch={handleSearch} results={results} setSearchData={setSearchData} runApis={runApis}/> */}
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tenant Name*
            </label>
            {/* <select
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Select Tenant"
              onChange={(e) => setSearchData(e.target.value)}
            >
              <option value="">Select Tenant</option>
              {tenantList?.length > 0 && tenantList?.map((e)=>{
                const {tenantName,unitNumber,userId,tenantId} = e
          
                let jsonString = JSON.stringify(e);
                return <option value={jsonString}>{tenantName}</option>}
              )}
            </select> */}

{/* const [searchData, setSearchData] = useState(null); */}

{/* return ( */}
  <div className="relative">
    <input
      list="tenantList"
      className="w-full px-3 py-2 border border-gray-300 rounded-md capitalize"
      placeholder="Select or enter tenant name"
      onChange={(e) => {
        const value = e.target.value.trim();
        const inputValue = value.charAt(0).toUpperCase() + value.slice(1);
        if (originalTenantData && editClick && originalTenantData.tenantId ) {
          const updatedObj = {
            ...originalTenantData,
            tenantName: inputValue,
            isNew: false,
          };
          setSearchData(JSON.stringify(updatedObj));
          return;
        }
        if (!inputValue) {
          const jsonObj = {
            tenantName: '',
            unitNumber: "",
            userId: "",
            tenantId: "",
            isNew: true,
          };
          setSearchData(JSON.stringify(jsonObj));
          return;
        }
        const foundTenant = tenantList?.find(
          (t) => t.tenantName?.toLowerCase() === inputValue.toLowerCase()
        );

        if (foundTenant) {
          setSearchData(JSON.stringify(foundTenant));
        } else {
          const jsonObj = {
            tenantName:inputValue,
            unitNumber: "",
            userId: "",
            tenantId: "",
            isNew: true,
          };
          setSearchData(JSON.stringify(jsonObj));
        }
      }}
    />

    <datalist id="tenantList">
      {tenantList?.length > 0 &&
        tenantList.map((tenant, index) => (
          <option className="w-100 w-full mx-5" key={index} value={tenant?.tenantName} />
        ))}
    </datalist>
  </div>
{/* ); */}

          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Unit Number
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              value={paymentData.unitNumber || ''}
              onChange={(e) => handleInputChange('unitNumber', e.target.value)}
            />
          </div>
        </div>
        {/* {console.log(selectedUser,"selectedUserselectedUser")} */}
        {(!isValidFuntion(selectedUser.memberId)) && 
        <div className="w-full mt-2 flex justify-end">
            <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700" onClick={()=>addUser()}>
              Submit
            </button>
        </div>}
        {(isValidFuntion(selectedUser.memberId)) && (
          <div className="w-full mt-2 flex justify-end">
            {!editClick && (
              <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 me-3" onClick={handleEditClick}>
                Edit
              </button>
            )}
            {editClick && (
              <>
                <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 me-3" onClick={handleSaveClick}>
                  Save
                </button>
                <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700" onClick={handleCancelClick}>
                  Cancel
                </button>
              </>
            )}
          </div>
        )}
      </div>
      {/* Payment Type */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Line of Business</h3>
        {/* <select
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          value={paymentData.lineOfBusiness}
          onChange={(e) => onChangePayment(e)}
        >
          <option value="" disabled>Select Line of Business</option>
          {businessLines?.map(({subscriptionId, subscriptionName}) => (
            <option key={subscriptionId} value={subscriptionId}>{subscriptionName}</option>
          ))}
        </select> */}
         <SearchableSelect
              // label="New -Service Type- Billed For"
              value={paymentData.lineOfBusiness}
              options={businessLines}
              optionLabel={(o) => o.subscriptionName}
              optionValue={(o) => o.subscriptionId}
              onChange={(value) => onChangePayment(value)}
              // disabled={isNotValidNullUndefile(paymentData.userAuthSubId) ? true : isServiceLocked ? true : false}
              placeholder={`Select Line of Business`}
              beforeOpen={handleBeforeOpen}
            />
            {paymentData.lineOfBusiness == 21 && <>
              <div className="flex w-100 justify-between align-center mt-2">
                <h3 className="text-lg font-semibold mb-2">Other Description</h3>
              </div>
              <input
                type="text"
                className="pl-3 pr-4 py-2 w-full border border-gray-300 rounded-md"
                placeholder='Enter Other Description'
                value={paymentData?.subscriptionName || ''}
                onChange={(e) =>{
                const value = e.target.value
                const inputValue = value.charAt(0).toUpperCase() + value.slice(1);
                handleInputChange('subscriptionName', inputValue)}}
              />
            </>
            }
      </div>
      {/* Amount */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Payment Amount</h3>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500">$</span>
          </div>
          <input
            type="text"
            className="pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md"
            value={formatToUS(paymentData?.amount) || ''}
            placeholder="0"
            min="0"
            step="1"
            onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/[^\d.,]/g, '');
              handleInputChange('amount', onlyNumbers || 0);
            }}
            onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
          />
        </div>
      </div>
      <PaymentForm handleBeforeOpen={handleBeforeOpen} paymentData={paymentData} handleInputChange={handleInputChange} setPaymentData={setPaymentData} />
      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
            <h2 className="text-xl font-semibold text-gray-800">Confirm Save</h2>
            <p className="mt-3 text-gray-600">
              Would you like to save before continuing?
            </p>
            <div className="mt-6 flex justify-end gap-3">
              <button onClick={handleSave} className="px-4 py-2 rounded-lg bg-green-600 text-white">
                Save
              </button>
              <button onClick={handleDiscard} className="px-4 py-2 rounded-lg bg-green-600 text-white">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    )
}

export default FederalWay;